import {createPage, setPageContent} from '@/tests';

describe('Dialog e2e', () => {
    it('should close dialog if open prop is set to false', async () => {
        const page = await createPage();

        await setPageContent(
            page,
            `                   
            <joy-dialog id="myDialog" open>
                 <p slot="dialog-header">I am the dialog header</p>
                 <p slot="dialog-subheader">I am the dialog subheader</p>
            </joy-dialog>`,
        );

        await page.$eval('joy-dialog', (elm: any) => {
            elm.open = false;
        });

        await page.waitForChanges();
        const dialog = await page.find('joy-dialog');
        const dialogVisible = await dialog.isVisible();
        expect(dialogVisible).toBe(false);
    });
});
